import { lt } from '@mews/framework';
import { DropDownButton, DropdownItem, IconName } from '@optimus-web/core';
import { TaskTemporalState, useTaskCloseMutation } from './query';

export const TaskContextMenu = ({ temporalState, id }: { id: string; temporalState: TaskTemporalState }) => {
    const closeTaskMutation = useTaskCloseMutation();

    if (temporalState === 'Pending' || temporalState === 'Future' || temporalState === 'Missed')
        return (
            <DropDownButton icon={IconName.More} variant="ghost" size="small">
                <DropdownItem
                    key="closeTask"
                    label={lt('Close')}
                    onClick={() => closeTaskMutation.mutate({ taskIds: [id] })}
                />
            </DropDownButton>
        );

    return null;
};
